import React, { useState } from 'react';
import QuizContext from '.';
import { QuizData } from '../typings';

type QuizContextProps = {
  children?: React.ReactNode;
};

const QuizContextProvider: React.FC<QuizContextProps> = ({ children }) => {
  const [quizData, setQuizdata] = useState<QuizData>({
    isQuizStarted: false,
    isQuizEnded: false,
    isForm: false,
    currentQuestion: 0,
    quizResponse: [],
    totalQuestions: 0,
    quizQuestions: [],
    isEntryModule: false,
  });

  const updateQuizData = (data: QuizData) => {
    setQuizdata({ ...data });
  };

  return <QuizContext.Provider value={{ quizData, updateQuizData }}>{children}</QuizContext.Provider>;
};

export default QuizContextProvider;
